import { render, staticRenderFns } from "./TestKVWebRTC.vue?vue&type=template&id=1c82be32&"
import script from "./TestKVWebRTC.vue?vue&type=script&lang=js&"
export * from "./TestKVWebRTC.vue?vue&type=script&lang=js&"
import style0 from "./TestKVWebRTC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
